/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterDimensions_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuInputRangeDimensions_itemSearch">;
    readonly " $refType": "SbRespRefineMenuFilterDimensions_itemSearch";
};
export type SbRespRefineMenuFilterDimensions_itemSearch$data = SbRespRefineMenuFilterDimensions_itemSearch;
export type SbRespRefineMenuFilterDimensions_itemSearch$key = {
    readonly " $data"?: SbRespRefineMenuFilterDimensions_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterDimensions_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterDimensions_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeDimensions_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '5e1268eefe3c5705cbcbd04f966defe2';
export default node;
